import { fetchUtility } from '~utilities/fetch';

export async function publicCountryListRequest(): Promise<Response> {
    return fetchUtility('/countries');
}
